import { Routes, Route, Navigate } from 'react-router-dom';
import MainLayout from '../../../layouts/MainLayout';
import FeedbackDashboard from './dashboard';

/**
 * Feedback Management Routes
 * Routing configuration for Feedback domain with MainLayout
 */
export default function FeedbackManagementRoutes() {
  return (
    <MainLayout domainKey="feedback">
      <Routes>
        <Route path="/" element={<FeedbackDashboard />} />
        <Route path="*" element={<Navigate to="/app/feedback" replace />} />
      </Routes>
    </MainLayout>
  );
}
